$(function () {
    
    $(document).on('submit', '[form-login]', function (event) {
        event.preventDefault();
        var data = {
            action: 'login',
            username: $("#f-username-dialog").val(),
            password: $("#f-password-dialog").val(),
        };
        $.ajax({
            type: "POST",
            dataType: "json",
            url: ajaxLng + '/ajax/user/',
            data: data,
            beforeSend: function () {},
            success: function (data) {
                if (data.redirect) {
                    window.location.href = data.redirect;
                }
                if (data.error) {
                    $('.error').text(data.error);
                }
            },
            error: function (xhr, desc, err) {
                console.log(xhr);
                console.log("Details: " + desc + "\nError:" + err);
            }
        });
    });
    
    $(document).on('submit', '[form-lost-password]', function (event) {
        event.preventDefault();
        var data = {
            action: 'lost-password',
            email: $("#f-email-dialog").val()
        };        
      
        $.ajax({
            type: "POST",
            dataType: "json",
            url: ajaxLng + '/ajax/user/',
            data: data,
            beforeSend: function () {},
            success: function (data) {
                if (data.redirect) {
                    window.location.href = data.redirect;
                }
                if (data.error) {
                    $('.error').text(data.error);
                }
                if (data.success) {
                    $('.success').text(data.success);
                }
            },
            error: function (xhr, desc, err) {
                console.log(xhr);
                console.log("Details: " + desc + "\nError:" + err);
            }
        });
    });
    
    $(document).on('click', '[data-logout]', function (event) {
        event.preventDefault();
        var data = {
            action: 'logout',
        };
        $.ajax({
            type: "POST",
            dataType: "json",
            url: ajaxLng + '/ajax/user/',
            data: data,
            beforeSend: function () {},
            success: function (data) {
                
                if (data.redirect) {
                    window.location.href = data.redirect;
                }
                
            },
            error: function (xhr, desc, err) {
                console.log(xhr);
                console.log("Details: " + desc + "\nError:" + err);
            }
        });
    });
    
});